import React, {
  ReactNode,
  useCallback,
  useEffect,
  useRef,
  useState,
} from "react";

import {
  StyledChildrenWrapper,
  StyledCollapseExpandSingleIcon,
  StyledDividerLine,
  StyledTitle,
  StyledWrapper,
} from "./Styles";
import { Button } from "../Button";

export interface EntitiesHeaderProps {
  className?: string;
  title: ReactNode;
  expanded?: boolean;
  onClick?: () => void;
  children?: ReactNode;
  readOnly?: boolean;
}

export const EntitiesHeader: React.FC<EntitiesHeaderProps> = ({
  onClick,
  title,
  children,
  expanded = true,
  readOnly = false,
  className,
}) => {
  const ref = useRef<HTMLDivElement | null>(null);
  const [open, setOpen] = useState(expanded || readOnly);

  useEffect(() => {
    setOpen(expanded || readOnly);
  }, [expanded, readOnly]);

  const handleOnClick = useCallback(() => {
    ref.current?.focus();
    setOpen((prev) => !prev);
    if (onClick) onClick();
  }, [onClick]);

  return (
    <StyledWrapper
      className={className}
      tabIndex={0}
      ref={ref}
      $expanded={open}
    >
      {!readOnly ? (
        <Button variant="text gray" size="small" onClick={handleOnClick}>
          <StyledCollapseExpandSingleIcon $expanded={open} />
          <StyledTitle $readOnly={readOnly} color="secondary" weight="medium">
            {title}
          </StyledTitle>
        </Button>
      ) : (
        <StyledTitle $readOnly={readOnly} color="secondary" weight="medium">
          {title}
        </StyledTitle>
      )}
      {!open && <StyledDividerLine data-testid="divider-line" />}
      {open && <StyledChildrenWrapper>{children}</StyledChildrenWrapper>}
    </StyledWrapper>
  );
};
